// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__21BD4","vLegacy":"SelectSecondary_vLegacy__zuNr4","error":"SelectSecondary_error__1PqOx","disabled":"SelectSecondary_disabled__3ftYM"};